import React from 'react'
import injectSheet from 'react-jss'
import {
  Tile,
  OptionGroupElements,
} from '../../'

const OptionGroup = (props) => {
  const {
    classes,
    compareOption,
    conflicts,
    handleClick,
    index,
    isSelected,
    node,
    requires,
  } = props

  return (
    <div className={`${classes.tileContainer} ${isSelected && classes.selected}`}>
      <Tile
        conflicts={conflicts}
        index={index}
        isSelected={isSelected}
        onClick={handleClick}
        requires={requires}
      >
        <div className={`${classes.contentContainer}`}>
          <h3 className={`${classes.tileName}`}>
            {node.title}
          </h3>
          <OptionGroupElements
            compareOption={compareOption}
            node={node}
          />
        </div>
      </Tile>
    </div>
  )
}

const styles = theme => ({
  tileContainer: {
    position: 'relative',
    width: '100%',
    backgroundColor: `${theme.colors.main_2}`,
  },
  contentContainer: {
    width: '100%',
    height: '100%',
  },
  tileName: {
    width: '100%',
    padding: `0 ${theme.sizes.gutter / 2}px`,
  },
})

export default injectSheet(styles)(OptionGroup)



// WEBPACK FOOTER //
// ./src/modules/core/components/optionGroup.jsx